
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { BasicInfoFields } from "./form-fields/BasicInfoFields";
import { AddressFields } from "./form-fields/AddressFields";
import { BusinessFields } from "./form-fields/BusinessFields";

interface SubscriptionFormFieldsProps {
  form: UseFormReturn<any>;
}

export function SubscriptionFormFields({ form }: SubscriptionFormFieldsProps) {
  console.log("=== SUBSCRIPTION FORM FIELDS DEBUG ===");
  console.log("Current form values:", form.getValues());
  console.log("isBusiness watched value:", form.watch("isBusiness"));
  console.log("businessName watched value:", form.watch("businessName"));
  console.log("=== END SUBSCRIPTION FORM FIELDS DEBUG ===");

  return (
    <>
      <BasicInfoFields form={form} />
      <AddressFields form={form} />
      <BusinessFields form={form} />
      
      {/* Automated Bin Day Detection Info */}
      <div className="p-4 rounded-lg border bg-green-50 border-green-200">
        <h3 className="font-medium text-green-800 mb-2 flex items-center gap-2">
          <span className="text-green-600">✓</span>
          We Handle Everything For You!
        </h3>
        <p className="text-sm text-green-700 mb-2">
          No need to worry about bin collection days - we automatically find your bin day from your council and keep track of any changes.
        </p>
        <p className="text-xs text-green-600 font-medium">
          Just provide your address and we'll determine the collection day after you subscribe!
        </p>
      </div>
    </>
  );
}
